import { Component, OnInit } from '@angular/core';
import {
  ComponentModalConfig,
  ModalSize,
  SuiModal,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { environment } from 'src/environments/environment';

interface IPersonnelInfoModalContext {
  data: any;
  title: any;
}

@Component({
  selector: 'app-personnel-info-modal',
  templateUrl: './personnel-info-modal.component.html',
  styleUrls: ['./personnel-info-modal.component.scss'],
})
export class PersonnelInfoModalComponent implements OnInit {
  baseUrl = environment.API_SERVER;
  constructor(
    private modalService: SuiModalService,
    public modal: SuiModal<IPersonnelInfoModalContext, void, void>
  ) {
    console.log(this.modal.context.data, 'data');
  }

  ngOnInit(): void {}
}

export class PersonnelInfoModal extends ComponentModalConfig<
  IPersonnelInfoModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(PersonnelInfoModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
